import classnames from 'classnames'
import styles from './ProductPageUiMisc.module.scss'
import AnimatedTextLines from '@/components/AnimatedTextLines/AnimatedTextLines'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef } from 'react'
import { formatNumber } from '@/utils'
import useStore from '@/store'

export const INDEX_NUMBER_OF_DIGITS = 3

const ProductPageUiMisc = forwardRef(
  // eslint-disable-next-line no-unused-vars
  ({ className, productData }, ref) => {
    const textLinesRefs = useRef({
      rangeLabel: null,
      totalItemsRangeLabel: null,
      scrollTextLabel: null,
    })
    const productPageActiveImage = useStore(state => state.productPageActiveImage)
    const lengthOfImagesText = useMemo(
      () => `${formatNumber(productData?.productData?.images?.length, INDEX_NUMBER_OF_DIGITS)}`,
      [productData?.productData?.images?.length],
    )

    useEffect(() => {
      if (productPageActiveImage) {
        const textToUpdate = formatNumber(productPageActiveImage.index + 1, 2)
        textLinesRefs.current.activeIndexLabel.updateText(textToUpdate)
        if (lengthOfImagesText) {
          textLinesRefs.current.rangeLabel.updateText(
            `${formatNumber(productPageActiveImage.index + 1, INDEX_NUMBER_OF_DIGITS)} - ${lengthOfImagesText}`,
          )
        }
      }
    }, [productPageActiveImage, lengthOfImagesText])

    useImperativeHandle(ref, () => ({
      animateIn: () => {
        Object.values(textLinesRefs.current).forEach($ref => {
          if ($ref) $ref.animate()
        })
      },
      animateOut: () => {
        Object.values(textLinesRefs.current).forEach($ref => {
          if ($ref) $ref.animateOut()
        })
      },
      reset: () => {
        Object.values(textLinesRefs.current).forEach($ref => {
          if ($ref) $ref.reset()
        })
      },
    }))

    return (
      <div className={classnames(styles.ProductPageUiMisc, className)}>
        {/* Active Index Label */}
        <div className={styles.activeIndexLabelContainer}>
          <AnimatedTextLines
            querySelector="span"
            ref={ref => {
              textLinesRefs.current.activeIndexLabel = ref
            }}
            autoAnimate={false}
            className={classnames(styles.activeIndexLabel__lines, styles.textLines)}
          >
            <span
              className={classnames(styles.activeIndexLabel, styles.textLinesValue)}
            >{`${formatNumber(1, 2)}`}</span>
          </AnimatedTextLines>
        </div>

        <div className={styles.rangeAndScrollContainer}>
          {/* Range Label */}
          <div className={styles.rangeLabelContainer}>
            <AnimatedTextLines
              querySelector="span"
              toAnimate="lines"
              ref={ref => {
                textLinesRefs.current.rangeLabel = ref
              }}
              autoAnimate={false}
              className={classnames(styles.rangeLabel__lines, styles.textLines)}
            >
              <span className={classnames(styles.rangeLabel, styles.textLinesValue)}>
                {`${formatNumber(1, INDEX_NUMBER_OF_DIGITS)} - ${lengthOfImagesText}`}
              </span>
            </AnimatedTextLines>
          </div>

          {/* Scroll Text Label */}
          <div className={styles.scrollTextLabelContainer}>
            <AnimatedTextLines
              querySelector="span"
              ref={ref => {
                textLinesRefs.current.scrollTextLabel = ref
              }}
              autoAnimate={false}
              className={classnames(styles.scrollTextLabel__lines, styles.textLines)}
            >
              <span className={classnames(styles.scrollTextLabel, styles.textLinesValue)}>(Scroll)</span>
            </AnimatedTextLines>
          </div>
        </div>
      </div>
    )
  },
)

ProductPageUiMisc.displayName = 'ProductPageUiMisc'

export default ProductPageUiMisc
